var map = {
	"./cn.json": "50d9",
	"./de.json": "cb40",
	"./dk.json": "6e31",
	"./en.json": "0e40",
	"./en_GB.json": "e2cc2",
	"./es.json": "913d",
	"./fi.json": "d2d8",
	"./fr.json": "e316",
	"./se.json": "83d8",
	"./th.json": "31ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adb0";